import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden p-2 text-foreground hover:text-primary transition-colors"
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile menu overlay */}
      <div className={`fixed inset-0 z-50 md:hidden pointer-events-none`}>
        {/* Backdrop */}
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            isOpen ? "opacity-60 pointer-events-auto" : "opacity-0"
          }`}
          onClick={() => setIsOpen(false)}
        />

        {/* Mobile menu panel */}
        <div
          className={`absolute top-0 right-0 w-64 bg-white border-l border-gray-200 shadow-2xl p-4 z-50
          max-h-screen overflow-y-auto transform transition-transform duration-300
          ${isOpen ? "translate-x-0 pointer-events-auto" : "translate-x-full"}`}
        >
          {/* Header */}
          <div className="flex items-center justify-between pb-4 border-b border-gray-200">
            <span className="font-semibold text-black">Menu</span>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 hover:text-primary transition-colors"
              aria-label="Close menu"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Menu Items */}
          <nav className="flex flex-col pt-4 space-y-4">
            <Link
              to="/"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>

            <Link
              to="/courses"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              Courses
            </Link>

            <Link
              to="/immigration-services"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              Immigration Services
            </Link>

            <Link
              to="/about"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              About Us
            </Link>

            <Link
              to="/contact"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              Contact
            </Link>

            <Link
              to="/news"
              className="font-medium hover:text-primary transition-colors py-2 text-black"
              onClick={() => setIsOpen(false)}
            >
              News
            </Link>


            {/* Student Login - Hidden for now, will add later
            <Link to="/login" onClick={() => setIsOpen(false)}>
              <Button className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold">
                Student Login
              </Button>
            </Link>
            */}
          </nav>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
